import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import styles from './RatingStars.module.scss';
const RatingStars = ({ field, count = 5, label = 'default', meta = false }) => {
    const { t } = useTranslation();
    const { value = 0, onChange } = field;
    const [selected, setSelected] = useState(Math.max(Math.min(Number(value), count), 0));
    const preparedList = useMemo(() => {
        let result = [];
        for (let i = 1; i <= count; i++) {
            result.push({ isActive: selected >= i, rate: i });
        }
        return result;
    }, [selected, count]);
    function handleClick(rate) {
        if (rate === selected) {
            rate = 0;
        }
        setSelected(rate);
        if (typeof onChange === 'function') {
            onChange(rate);
        }
    }
    return (_jsxs("div", Object.assign({ className: styles.ratingStars }, { children: [_jsx("div", Object.assign({ className: styles.group }, { children: preparedList.map((item, index) => (_jsx("div", { className: classNames(styles.item, item.isActive && styles.active), onClick: () => handleClick(item.rate) }, index))) })), meta && (_jsx("div", Object.assign({ className: styles.meta }, { children: t(`rating.${label}_interval`, { postProcess: 'interval', count: selected }) })))] })));
};
export default RatingStars;
